export async function loadGenericPolygonShape(engine, refresh = true) {
    const { PolygonDrawer } = await import("./PolygonDrawer.js");
    await engine.addShape("polygon", new PolygonDrawer(), refresh);
}
export async function loadTriangleShape(engine, refresh = true) {
    const { TriangleDrawer } = await import("./TriangleDrawer.js");
    await engine.addShape("triangle", new TriangleDrawer(), refresh);
}
export async function loadPolygonShape(engine, refresh = true) {
    await loadGenericPolygonShape(engine, refresh);
    await loadTriangleShape(engine, refresh);
}
